const api = '/api/v1/u013_p_fixed_phrase_controller.php';
import axios from 'axios';
export const fixed_phrase_repository =  {
    get(user_id){
        return  axios.get(`${api}?USER_ID=${user_id}`);
    },
    upd(data){
        return  axios.post(api, data);
    }
};

